import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBlock = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.5c-4.57 0-8.5 3.887-8.5 8.5 0 1.98.719 3.938 1.983 5.456L17.456 5.483A8.6 8.6 0 0 0 12 3.5m6.517 3.044L6.544 18.517A8.6 8.6 0 0 0 12 20.5c4.618 0 8.5-3.882 8.5-8.5 0-1.98-.719-3.938-1.983-5.456M2 12C2 6.553 6.607 2 12 2c2.628 0 5.212 1.07 7.071 2.929A10.08 10.08 0 0 1 22 12c0 5.447-4.553 10-10 10-2.628 0-5.213-1.07-7.071-2.929A10.08 10.08 0 0 1 2 12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBlock;
